<template>
  <div class="flex justify-center items-center w-fit max-w-fit gap-2">
    <ViewListIcon
      @click="listType = 'list'"
      :class="[
        'w-10 p-2 border x cursor-pointer rounded-md',
        {
          'text-white bg-untitled-gray-400 hover:text-untitled-gray-600 border-untitled-gray-200 hover:bg-untitled-gray-100':
            listType === 'list' && !kintzApp,
          'bg-white border-untitled-gray-200 hover:bg-untitled-gray-100': listType !== 'list' && !kintzApp,
          'bg-kintz-primary-1 text-kintz-primary-2 border-kintz-primary-3': listType === 'list' && kintzApp,
          'bg-kintz-primary-3 text-kintz-primary-4 border-kintz-primary-1': listType !== 'list' && kintzApp,
        },
      ]"
    />
    <ViewGridIcon
      @click="listType = 'grid'"
      :class="[
        'w-10 p-2 border  cursor-pointer rounded-md',
        {
          'text-white bg-untitled-gray-400 border-untitled-gray-200 hover:bg-untitled-gray-100 hover:text-untitled-gray-600':
            listType === 'grid' && !kintzApp,
          'bg-white border-untitled-gray-200 hover:bg-untitled-gray-100': listType !== 'grid' && !kintzApp,
          'bg-kintz-primary-1 text-kintz-primary-2 border-kintz-primary-3': listType === 'grid' && kintzApp,
          'bg-kintz-primary-3 text-kintz-primary-4 border-kintz-primary-1': listType !== 'grid' && kintzApp,
        },
      ]"
    />
  </div>
</template>

<script setup>
import { useHomeTabsStore } from "@/stores/home/useHomeTabs.store";
import { storeToRefs } from "pinia";

const kintzApp = inject("kintz-app", false);

const homeTabsStore = useHomeTabsStore();

import { ViewListIcon, ViewGridIcon } from "@heroicons/vue/solid";
import { inject } from "vue";
const { listType } = storeToRefs(homeTabsStore);
</script>

<style lang="scss" scoped></style>
